import {
  useGetQuery,
  useLazyGetQuery,
  usePostMutation,
  usePutMutation,
} from "slices/api";
import { BACKUP_POWER, BILLING_CALCULATIONS, BILLING_CYCLE } from "tagTypes";

export const useGetBackupPowerQuery = (billingCycleId, query = {}) =>
  useGetQuery({
    endpoint: `/billing-cycle/${billingCycleId}/backup-power-bill-calculation`,
    query,
    tags: [BACKUP_POWER],
  });

export const useGetUserBackupPowerCalculationsQuery = () =>
  useGetQuery({
    endpoint: "/backup-power-bill-calculation/user/unpaid-bill",
    tags: [BACKUP_POWER, BILLING_CALCULATIONS],
  });

export const useLazyGetBackupPowerQuery = () => {
  const [getBackupPower, data] = useLazyGetQuery();
  const getBackupPowerData = async (billingCycleId, query = {}) =>
    await getBackupPower(
      {
        endpoint: `/billing-cycle/${billingCycleId}/backup-power-bill-calculation`,
        query,
        tags: [BACKUP_POWER],
      },
      true
    ).unwrap();
  return [getBackupPowerData, data];
};

export const usePostDispatchBackupPowerMutation = () => {
  const [dispatchBackupPower, data] = usePostMutation();
  const setBillsPdf = async (billCycleId, payload = {}) =>
    await dispatchBackupPower({
      endpoint: `/billing-cycle/${billCycleId}/dispatch-backup-power-bill`,
      payload,
      toastMessage: "Backup power bills dispatched successfully",
      tags: [BACKUP_POWER],
    }).unwrap();
  return [setBillsPdf, data];
};

export const usePostGenerateBackupPowerMutation = () => {
  const [generateBackupPowerBills, data] = usePostMutation();
  const generateBackupPowerBill = async (billCycleId, payload = {}) =>
    await generateBackupPowerBills({
      endpoint: `/billing-cycle/${billCycleId}/backup-power-bill-calculation`,
      payload,
      toastMessage:
        "You will be notified once all bill calculations are generated",
      tags: [BACKUP_POWER, BILLING_CYCLE],
    }).unwrap();
  return [generateBackupPowerBill, data];
};

export const usePostUploadBackupPowerBillsMutation = () => {
  const [uploadBackupPowerBills, data] = usePostMutation();
  const uploadBackupPowerBill = async (payload = {}) =>
    await uploadBackupPowerBills({
      endpoint: "/upload-backup-power-bill-zip",
      payload,
      toastMessage: "Backup power bills uploaded successfully",
      tags: [BACKUP_POWER, BILLING_CYCLE],
    }).unwrap();
  return [uploadBackupPowerBill, data];
};
//
export const usePostBackupPowerBillPaymentMutation = () => {
  const [dispatchBills, data] = usePostMutation();
  const setBillsPdf = async (calculationId, query = {}) =>
    await dispatchBills({
      endpoint: `/${calculationId}/backup-power-bill-payment`,
      query,
      tags: [BACKUP_POWER],
    }).unwrap();
  return [setBillsPdf, data];
};

export const usePutUpdateBackupPowerStatusMutation = () => {
  const [updateBackupPowerBillsStatus, data] = usePutMutation();
  const updateBackupPowerStatus = async (payload, toastMessage) =>
    await updateBackupPowerBillsStatus({
      endpoint: "/backup-power-bill-calculation/approve",
      payload: payload || {},
      toastMessage,
      tags: [BACKUP_POWER],
    }).unwrap();
  return [updateBackupPowerStatus, data];
};
